import React from 'react';
import LandingNav from './components/LandingNav';
import HeroSection from './components/HeroSection';
import StatsSection from './components/StatsSection';
import FeaturesSection from './components/FeaturesSection';
import SiemensSection from './components/SiemensSection';
import HowItWorks from './components/HowItWorks';
import EpoSection from './components/EpoSection';
import LandingFooter from './components/LandingFooter';
import './landing.scss';

const LandingPage = () => (
  <div className="landing-page">
    <LandingNav />
    <HeroSection />
    <StatsSection />
    <FeaturesSection />
    <SiemensSection />
    <HowItWorks />
    <EpoSection />
    <LandingFooter />
  </div>
);

export default LandingPage;
